export default __webpack_public_path__ + "static/media/forkIcon.3dbc1cf4.svg";